export default {
    'account-info': 'معلومات الحساب',
    save: 'حفظ',
    cancel: 'إلغاء',
    'account-name': 'اسم الحساب',
    'main-account': 'الحساب الأساسي',
    
    'account-type': {
        title: 'نوع الحساب',
        main: 'أساسي',
        sub: 'فرعي',
    },
    
    'final-accounts': {
        title: 'الحساب الختامي',
        operations: 'تشغيل',
        trade: 'مُتاجرة',
        'gains-and-losses': 'أرباح وخسائر',
        budget: 'ميزانية',
    },

    'custom-statement': 'كشف مُخصص',
    'max-debit-amount': 'سقف المدين',
    'max-credit-amount': 'سقف الدائن',
    'debt-is-forbidden': 'ممنوع من الدين',
    'notes': 'ملاحظات',
    'contect-info': {
        title: 'معلومات التواصل',
        'mobile-number': 'رقم الجوال',
        'phone-number': 'رقم الهاتف',
        email: 'البريد الإلكتروني',
        address: 'العنوان',
    },

    'edit-account': 'تعديل حساب',
    'create-account': 'إنشاء حساب',
}